import React, { useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { classNames } from 'primereact/utils';



const AutoCompleteDropdown = ({
    habilitar = false,
    value,
    handleInputChange = () => { },
    onValueChange = () => { },
    Items,
    field,
    name,
    tabIndex,
    label,
    itemTemplate,
    hidden = false,
    placeholder = null,
    className = null,
    labelStyle = {}
}) => {

    const [filteredItems, setFilteredItems] = useState([]);

    const completeMethod = (event, items) => {
        let query = event.query;
        let _filteredItems = [];

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item[field].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                // console.log(item);
                _filteredItems.push(item);
            }
        }
        // console.log(_filteredItems);
        setFilteredItems(_filteredItems);
    }

    const onBlur = (e) => {

        if (typeof value === 'string') {
            handleInputChange({ target: { name: name, value: null } });
            onValueChange({ value: null });
        }

    }

    const selectItem = (item, e) => {
        handleInputChange({ target: { name: name, value: item.value } });
        onValueChange({ value: item.value });
    }

    return (
        <div className={classNames('AutoCompleteContainer animate__animated animate__fadeIn' + name, { hidden: hidden })} style={{ zIndex: 10000 }} >
            <span className='encabezado__contenido p-float-label AutoCompleteDropdown'>
                <AutoComplete
                    id={name}
                    disabled={habilitar}
                    name={name}
                    value={value} 
                    tabIndex={tabIndex}
                    suggestions={filteredItems}
                    completeMethod={e => completeMethod(e, Items)}
                    field={field}
                    itemTemplate={itemTemplate ?? (e => { return e[field] })}
                    selectedItemTemplate={e => { return e[field] }}
                    tooltip={value?.field ?? null}
                    tooltipOptions={{ position: 'top' }}
                    onChange={(e) => { handleInputChange(e); onValueChange(e) }}
                    aria-label={field}
                    className={classNames('autocompleteInput', className)}
                    onSelect={selectItem}
                    onBlur={e => onBlur()}
                    placeholder={placeholder}
                    // autoHighlight
                    dropdown
                />
                <label style={labelStyle}>{label ?? name}</label>
            </span>
        </div >
    )
}

export default AutoCompleteDropdown